(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-links-list"] && !Shopify.designMode) return;
  try {
    
  const SECTION = '.collection-links-list';
  const TRACK = 'slideshow-slides, [data-carousel-track]';
  let booted = false;
  let image = null;

  /* Pages et débordement mesurés : les entrées se dimensionnent sur leur libellé, leur nombre par page n'est pas connu d'avance. */
  const adjust = () => {
    for (const sec of document.querySelectorAll(SECTION)) {
      const track = sec.querySelector(TRACK);
      if (!track || track.clientWidth === 0) continue;

      sec.classList.toggle('collection-links-list--scrolling', track.scrollWidth > track.clientWidth + 1);

      const pages = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth));
      for (const [i, point] of sec.querySelectorAll('[class*="__mark"], [class*="--mark"]').entries()) {
        const tooMany = i >= pages;
        point.toggleAttribute('hidden', tooMany);
        point.setAttribute('aria-hidden', tooMany ? 'true' : 'false');
      }
    }
  };

  const schedule = () => {
    if (image == null) image = requestAnimationFrame(() => { image = null; adjust(); });
  };

  const boot = () => {
    if (booted || !document.querySelector(SECTION)) return;
    booted = true;
    adjust();
    addEventListener('load', schedule, { once: true });
    addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(schedule);

    const observer = new ResizeObserver(schedule);
    for (const sec of document.querySelectorAll(SECTION)) {
      const track = sec.querySelector(TRACK);
      if (track) observer.observe(track);
    }
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };

  boot();
  document.addEventListener('shopify:section:load', () => {
    boot();
    schedule();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  const LIST = 'blog-posts-list';
  const mobile = matchMedia('(max-width: 749px)');
  let booted = false;

  const sync = () => {
    for (const list of document.querySelectorAll(LIST)) {
      const block = list.querySelector('.blog-posts__newsletter .email-signup-block');
      if (!block) continue;

      if (!mobile.matches) {
        block.style.removeProperty('min-height');
        continue;
      }

      let tallest = 0;
      for (const card of list.querySelectorAll('.blog-post-item:not(.blog-posts__newsletter)')) {
        tallest = Math.max(tallest, card.getBoundingClientRect().height);
      }
      block.style.minHeight = tallest ? `${Math.round(tallest)}px` : '';
    }
  };

  const onImage = (event) => {
    if (event.target instanceof HTMLImageElement && event.target.closest(LIST)) sync();
  };

  const boot = () => {
    if (booted || !document.querySelector(LIST)) return;
    booted = true;
    sync();
    mobile.addEventListener('change', sync);
    addEventListener('resize', sync);
    addEventListener('load', sync);
    /* `load` d'une image ne remonte pas : on l'écoute en capture. */
    document.addEventListener('load', onImage, { capture: true });
  };

  boot();
  document.addEventListener('shopify:section:load', () => {
    boot();
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-collections-enhanced"] && !Shopify.designMode) return;
  try {
    
  const SECTION = '.sub-collections-enhanced';
  const TRACK = 'slideshow-slides, [data-carousel-track]';
  let booted = false;
  let frame = null;

  /* Le débordement réel de la piste décide si les flèches et la progression ont lieu d'être. */
  const sync = () => {
    for (const section of document.querySelectorAll(SECTION)) {
      const track = section.querySelector(TRACK);
      if (!track) continue;
      section.classList.toggle('sub-collections-enhanced--scrolling', track.scrollWidth > track.clientWidth + 1);
    }
  };

  const schedule = () => {
    if (frame == null) frame = requestAnimationFrame(() => { frame = null; sync(); });
  };

  const boot = () => {
    if (booted || !document.querySelector(SECTION)) return;
    booted = true;
    sync();
    addEventListener('load', schedule, { once: true });
    addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(schedule);

    const observer = new ResizeObserver(schedule);
    for (const section of document.querySelectorAll(SECTION)) {
      const track = section.querySelector(TRACK);
      if (!track) continue;
      observer.observe(track);
      if (track.firstElementChild) observer.observe(track.firstElementChild);
    }
  };

  boot();
  document.addEventListener('shopify:section:load', () => {
    boot();
    schedule();
  });

  } catch(e) { console.error(e); }
})();
})();
